import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { Checkbox } from '../../atoms/checkbox.component';
import { BoolListLayoutOption, type BoolListOptionProps } from '../../layouts/bool-list-layout.component';

const checklistOptionStyle1 = css`
  margin-bottom: ${theme.spacing(2)};
`;

type Props = Omit<BoolListOptionProps<'checkbox'>, 'field'>;

export const CheckListOption = (props: Props) => {
  return <BoolListLayoutOption {...props} className={cx(checklistOptionStyle1, props.className)} field={Checkbox} />;
};
